import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'project';

export const projectActions = createTypes([
    'save',
    'setFileName',
    'setProgress',
    'setStatus',
    'saveCourseProjectOverview',
    'cleanAllCourseProjectOverview'
], namespace);

export const projectActionsCreators = {
    save: fromType(projectActions.save, ['project']),
    setFileName: fromType(projectActions.setFileName, ['filename', 'projectId']),
    setProgress: fromType(projectActions.setProgress, ['progress', 'projectId']),
    setStatus: fromType(projectActions.setStatus, ['status', 'projectId']),
    saveCourseProjectOverview: fromType(projectActions.saveCourseProjectOverview, ['courseId', 'overviewData']),
    cleanAllCourseProjectOverview: fromType(projectActions.cleanAllCourseProjectOverview, ['courseId'])
}